import React, { ReactNode } from 'react';
import { Outlet, Link } from 'react-router-dom';
import { Navigation } from './Navigation';
import { MobileNav } from './MobileNav';
import { useAuth } from '../contexts/AuthContext';
import { PushPermissionPrompt } from './notifications/PushPermissionPrompt';
import logoImage from '../assets/logo.svg';

export function NewLayout({ children }: { children?: ReactNode }) {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Desktop Sidebar */}
      <div className="hidden lg:fixed lg:inset-y-0 lg:flex lg:w-64 lg:flex-col">
        <Navigation />
      </div>

      {/* Mobile Header */}
      <div className="lg:hidden sticky top-0 z-40 bg-white border-b border-gray-200 px-4 h-14 flex items-center justify-between">
        <img src={logoImage} alt="GamePath" className="h-5" />
        <Link to="/profile" className="flex items-center gap-2 min-h-[44px] min-w-[44px] justify-center">
          <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
            <span className="text-xs font-semibold text-green-700">
              {user?.profile?.firstName?.[0]}{user?.profile?.lastName?.[0]}
            </span>
          </div>
        </Link>
      </div>

      {/* Main Content */}
      <div className="lg:pl-64">
        <main className="pb-20 lg:pb-8">
          {children || <Outlet />}
        </main>
      </div>

      {/* Mobile Bottom Navigation */}
      <div className="lg:hidden">
        <MobileNav />
      </div>

      {/* Push Notification Permission Prompt */}
      <PushPermissionPrompt />
    </div>
  );
}
